var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.platform)?_c('el-tooltip',{attrs:{"content":_vm.platform.name,"placement":"top-start"}},[_c('span',{staticClass:"badge-platform",class:{badge: true, [`${_vm.custom_class}`]: !!_vm.custom_class, [`${_vm.calcClass}`]: true},style:({'background-color': _vm.color})},[_c('span',[_vm._v(_vm._s(_vm.text))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }